module.exports = {
          srcSet: __webpack_public_path__ + "e7ab3c94f4d074fda560d3cd401933a4-500.png"+" 500w",
          images:[ {path: __webpack_public_path__ + "e7ab3c94f4d074fda560d3cd401933a4-500.png",width: 500,height: 627}],
          src: __webpack_public_path__ + "e7ab3c94f4d074fda560d3cd401933a4-500.png",
          toString:function(){return __webpack_public_path__ + "e7ab3c94f4d074fda560d3cd401933a4-500.png"},
          
          width: 500,
          height: 627
        }